"use client"

import type { ReactNode } from "react"

import { Label } from "./label"
import { cn } from "../lib/cn"

interface FormFieldProps {
  label: string
  htmlFor?: string
  hint?: ReactNode
  error?: string
  children: ReactNode
  action?: ReactNode
  className?: string
}

export function FormField({ label, htmlFor, hint, error, children, action, className }: FormFieldProps) {
  return (
    <div data-slot="form-field" className={cn("flex min-w-0 flex-col gap-1.5", className)}>
      <div className="flex min-h-4 items-center justify-between gap-2">
        <Label htmlFor={htmlFor} className="min-w-0 text-xs font-medium text-foreground">{label}</Label>
        {action}
      </div>
      {children}
      {hint && <span className="text-[11px] leading-4 text-muted-foreground">{hint}</span>}
      {error && <span role="alert" className="text-[11px] leading-4 text-destructive">{error}</span>}
    </div>
  )
}
